import imageMotif from "src/assets/images/motif.png";

export function ContactMotifComponent() {
  return (
    <div>
      <img src={imageMotif} className="w-full" />
    </div>
  );
}
